import { Query } from '@/types/queryTypes'

export default function cleanAdyenQueryParams(query: Query) {
  const cleanedQuery = { ...query }

  ;['force-prepayment', 'force-imprint', 'token', 'redirectResult'].forEach((param) => {
    delete cleanedQuery[param]
  })

  return cleanedQuery
}
